<template>
    <section>
        <div class ="flex fixed fixed-max-sm middle space-between vertical-xs">
            <div class="agent-bar-img">
                <div>
                    <img  v-for="agent in agents" loading="lazy" :src=agent.image :alt="agent.fullName">
                </div>
                <div>
                    <b>Match with a local agent today!</b>
                </div>
            </div>
            <div>
                <button href="javascript:;" @click="openHotlead" class="btn primary regular">Connect Now</button>
            </div>
        </div>
    </section>
</template>
<script src="./agent-banner.js"></script>
<style lang="scss">
@use "./agent-banner.scss" as *;
</style>